import type { FormikValues } from 'formik';
import { withFormik } from 'formik';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { SET_ONBOARDING_VALUES } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { validation } from './validation';

import { PharmacyFormRenderer } from '.';

type PharmacyStepProps = {
  handleNextClick: () => void;
  setShowFooter: React.Dispatch<React.SetStateAction<boolean>>;
  onSetTransferFormValues: (values: FormikValues) => void;
  isOnboarding: boolean;
};

const makeMapStateToProps = (onboardingForm?) => {
  return () => {
    const initialZipCode = onboardingForm?.onboardingForm?.zipCode;
    const transferForm = onboardingForm;
    return {
      transferForm,
      initialZipCode,
    };
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSetTransferFormValues: (values: FormikValues) => {
    dispatch({
      type: SET_ONBOARDING_VALUES,
      values: {
        pharmacyName: values.pharmacyName,
        pharmacyPhone: values.pharmacyPhone,
        pharmacyStreets: values.pharmacyStreets,
      },
    });
  },
});

const connector = connect(makeMapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export type ComponentProps = PropsFromRedux & PharmacyStepProps;

const enhanceWithFormik = withFormik<ComponentProps, FormikValues>({
  mapPropsToValues: ({ transferForm, initialZipCode }) => {
    let pharmacyZipCode = transferForm.pharmacyZipCode;
    if (!pharmacyZipCode || pharmacyZipCode === '') {
      pharmacyZipCode = initialZipCode;
    }

    const commonValues = {
      ...validation.initialValues,
      ...transferForm,
      pharmacyZipCode,
      pharmacyZipCodeLatitude: transferForm.pharmacyZipCodeLatitude,
      pharmacyZipCodeLongitude: transferForm.pharmacyZipCodeLongitude,
    };
    return commonValues;
  },

  validationSchema: validation.schema,
  validateOnChange: true,
  validateOnBlur: true,
  validateOnMount: true,
  handleSubmit: (values, { props }) => {
    const { onSetTransferFormValues, handleNextClick, setShowFooter } = props;
    onSetTransferFormValues(values);
    // Reinstate copyright footer visibility when leaving the pharmacy component.
    setShowFooter(true);
    handleNextClick();
  },
});

export const PharmacySearch = compose(connector, enhanceWithFormik)(PharmacyFormRenderer);
